import type { JSONContent } from '@/types/api'

export interface Workspace {
  id: string
  name: string
}

export interface Draft {
  id: string
  title: string
  lastModified: Date
  createdAt: string
  lastOpenedAt: string
  workspaceId: string
  content?: JSONContent
}

export type VeevaSubtype =
  | 'Publication'
  | 'Data on File'
  | 'Labeling'
  | 'Government/Authority Report'
  | 'Website'
  | 'Monograph'
  | 'Instructions for Use'
  | 'Important Safety Information'

export interface LibraryItem {
  id: string
  filename: string
  status: 'processing' | 'indexed' | 'failed'
  workspaceId: string
  // Veeva / Pharma Fields
  title: string
  fileSubtype: VeevaSubtype
  shortCitation?: string
  amaCitation: string
  /** User-provided override for the AMA citation. When set, displayed in
   *  place of `amaCitation`. Cleared = falls back to AI-generated value. */
  amaCitationOverride?: string
  /** User-provided override for the short AMA citation (publications only). */
  shortCitationOverride?: string
  abstract?: string
  // Detailed Metadata
  source?: string
  sourceDate?: string
  authors?: string[]
  doi?: string
  pmid?: string
  url?: string
  // Bibliographic Fields
  language?: string
  volume?: string
  pageRange?: string
  // Medical Fields
  meshTerms?: string[]
  meshSource?: 'pubmed' | 'mesh_on_demand'
  activeIngredients?: string[]
  // Regulatory Specific
  brand?: string
  productName?: string
  companyName?: string
  therapeuticArea?: string
  isActiveInRag: boolean
  // Provenance / dedup
  supersededBy?: string
  supersededAt?: string
  supersededVia?: 'hash' | 'doi' | 'pmid' | 'text_fingerprint'
  originalWorkspaceId?: string
  enrichmentTelemetrySummary?: {
    path_taken?: string[]
    field_sources?: Record<string, string>
    [key: string]: unknown
  }
}

export const workspaces: Workspace[] = [
  { id: 'ws-1', name: 'Vitiligo Launch' },
  { id: 'ws-2', name: 'Oncology Pipeline' },
  { id: 'ws-3', name: 'Rare Disease Portfolio' },
]

export const drafts: Draft[] = []

export const libraryItems: LibraryItem[] = []
